import React from 'react';

const Pagination = ({ 
  page, 
  setPage, 
  pagination 
}) => {
  // Early return if no pagination data
  if (!pagination) return null;

  const { total_items, current_page, items_per_page = 10 } = pagination;
  const totalPages = Math.ceil(total_items / items_per_page);

  // Generate array of page numbers to display
  const getPageNumbers = () => {
    const delta = 2; // Number of pages to show before and after current page
    const range = [];
    const rangeWithDots = [];

    // Always show first page
    range.push(1);

    for (let i = current_page - delta; i <= current_page + delta; i++) {
      if (i > 1 && i < totalPages) {
        range.push(i);
      }
    }

    // Always show last page
    if (totalPages > 1) {
      range.push(totalPages);
    }

    // Add dots between numbers if needed
    let l;
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center mt-4">
      <div className="d-flex justify-content-between align-items-center w-100 mb-3">
        <div>
          Prenotazioni totali: {total_items}
        </div>
        <div>
          Pagina {current_page} of {totalPages}
        </div>
      </div>

      <nav aria-label="Page navigation">
        <ul className="pagination">
          <li className={`page-item ${current_page === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(current_page - 1)}
              disabled={current_page === 1}
            >
              Precedente
            </button>
          </li>

          {getPageNumbers().map((pageNum, index) => (
            <li 
              key={index} 
              className={`page-item ${pageNum === current_page ? 'active' : ''} ${pageNum === '...' ? 'disabled' : ''}`}
            >
              <button
                className="page-link"
                onClick={() => pageNum !== '...' && handlePageChange(pageNum)}
                disabled={pageNum === '...'}
              >
                {pageNum}
              </button>
            </li>
          ))}

          <li className={`page-item ${current_page === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(current_page + 1)}
              disabled={current_page === totalPages}
            >
              Successiva
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;